
import { MarketType, MarketAllowEmpty } from '../types/market'
import { safelyGetNestedValue } from 'widgets-shared/utilities'
import { getMeasurablePrice } from './getMeasurablePrice'

const marketsMap: { [marketId in string]: { [marketName in string ]: string } } = {
  '431': {
    moneyLine: '8779'
  },
  '432': {
    spread: '147',
    overUnder: '286',
    moneyLine: '115'
  },
  '2155': {
    spread: '147',
    overUnder: '286',
    moneyLine: '115'
  },
  '2708': {
    spread: '147',
    overUnder: '286',
    moneyLine: '115'
  },
  '296': {
    spread: '106',
    overUnder: '263',
    moneyLine: '103'
  },
  '2254': {
    spread: '106',
    overUnder: '263',
    moneyLine: '103'
  },
  '610': {
    spread: '141',
    overUnder: '282',
    moneyLine: '183'
  },
  '36': {
    spread: '82',
    overUnder: '259',
    moneyLine: '2'
  },
  '1033': {
    spread: '147',
    overUnder: '286',
    moneyLine: '115'
  },
  '597': {
    spread: '97',
    overUnder: '335',
    moneyLine: '117'
  },
  '2169': {
    spread: '97',
    overUnder: '335',
    moneyLine: '117'
  },
  '190': {
    spread: '82',
    overUnder: '259',
    moneyLine: '2'
  },
  '53': {
    spread: '82',
    overUnder: '259',
    moneyLine: '2'
  },
  '2072': {
    spread: '82',
    overUnder: '259',
    moneyLine: '2'
  },
  '19': {
    spread: '82',
    overUnder: '259',
    moneyLine: '2'
  },
  '40': {
    spread: '82',
    overUnder: '259',
    moneyLine: '2'
  },
  '1034': {
    spread: '106',
    overUnder: '263',
    moneyLine: '103'
  },
  '12156': {
    spread: '147',
    overUnder: '286',
    moneyLine: '115'
  },
  '14066': {
    moneyLine: '8779'
  },
  '1035': {
    spread: '106',
    overUnder: '263',
    moneyLine: '103'
  },
  '215': {
    spread: '82',
    overUnder: '259',
    moneyLine: '2'
  },
  '15490':{
    spread: '106',
    overUnder: '263',
    moneyLine: '103'
  }
}

export const marketTypes = {
  spread: 'POINT_SPREAD',
  overUnder: 'OVER_UNDER',
  moneyLine: 'MONEY_LINE'
} as { [marketType in string]: MarketType }

export function getMarketType(competitionId: string, marketTypeId: string): MarketType | null {
  const competitionMap = marketsMap[competitionId]
  for (const marketKey in competitionMap) {
    if (competitionMap[marketKey] === marketTypeId) return marketTypes[marketKey]
  }
  return null
}

export function getHighestPriceInMarkets(markets: Array<MarketAllowEmpty>): number {
  return markets && markets.reduce((currentHighest, market) => {
    const highSelection = market.selections.reduce((selHighest, sel) => {
      const price = safelyGetNestedValue(sel, ['price', 'decimal'], getMeasurablePrice(sel && sel.price)) as number
      return price > selHighest ? price : selHighest
    }, 0)
    return highSelection > currentHighest ? highSelection : currentHighest
  }, 0)
}
